import React, { Component } from 'react';
import {
	TreeLayer,
	TreeNodeProps,
	TreeModel,
	TreeModelContext,
} from '../../../atoms/tree-layer';
import { FolderView } from './folder-view';

type Props = TreeNodeProps<undefined>;
type State = { isOpen: boolean };

export class InnerNode extends Component<Props, State> {
	static contextType = TreeModelContext;

	constructor(props: Props, context: TreeModel) {
		super(props, context);

		const treeModel = context;
		const isContainingSelectedFile =
			(treeModel.selectedFile && treeModel.selectedFile.startsWith(props.node.id)) ||
			false;

		this.state = { isOpen: isContainingSelectedFile };
	}

	updateOpen = (isOpen: boolean) => this.setState({ isOpen });

	render() {
		const { node, depth, getTreeNodeComponent } = this.props;
		const { isOpen } = this.state;
		return (
			<FolderView isOpen={isOpen} onOpenChange={this.updateOpen} {...this.props}>
				{isOpen && node.children && (
					<TreeLayer<undefined>
						childNodes={node.children}
						depth={depth}
						getTreeNodeComponent={getTreeNodeComponent}
					/>
				)}
			</FolderView>
		);
	}
}
